import React from 'react';
import { LinearProgress } from '@material-ui/core';
import { makeStyles } from "../../styles/index";
var useStyles = makeStyles({
    root: {},
    colorPrimary: function (props) { return ({
        backgroundColor: props.bgColor,
    }); },
    barColorPrimary: function (props) { return ({
        backgroundColor: props.progressColor,
    }); },
}, { name: 'SnProgressBar' });
export var ProgressBar = function (props) {
    var className = props.className, style = props.style, variant = props.variant, value = props.value;
    var classes = useStyles(props);
    return (React.createElement(LinearProgress, { classes: classes, className: className, style: style, value: Math.min(Math.max(value, 0), 100), variant: variant }));
};
